import React from 'react';
import * as ReactDOM from 'react-dom';

import {useDomObserver} from 'common/hooks/useDomObserver';

interface PortalProps {
	portalId?: string;
	children: React.ReactNode;
}

const Portal: React.FC<PortalProps> = ({portalId = '', children}) => {
	const node = useDomObserver(portalId);
	return ReactDOM.createPortal(children, node || document.body);
}

export default React.memo(Portal);
